import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const LBS_AngerChild = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='LBS_AngerChild' className='file-pdf-document'>
            <div className='file-template'>

            <p className='w-750'><h2>Level 2-Anger-Child Age 11-17 <sup>*</sup></h2>
            <span className='small'><sup>*</sup>PROMIS Emotional Distress-Calibrated Anger Measure-Pediatic<sup>1</sup>
            </span>
                <br />
                <b>Istructions to the Child:</b>On the DSM-5 Level 1 cross-cutting questionnaire that you just completed, you indicated that during the past 2 weeks you have been bothered by "feeling irritated or easily annoyed" and/or "feeling angry or lost your temper" at a mild or greater level of severity. The questions below ask about these feelings in more detail and especially how often you have been bothered by a list of symptoms<b>during the past 7 days.</b>
                </p>

                <table>
                    <tr>
                        <td className='w-650'>&nbsp;</td>
                        <td className='w-100'><b>Clinician Use</b></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-200'> <span className='eleHeader'>{`In the Past Seven (7) days`}</span></td>
                        <td className='w-70'> <span className='eleHeader'>Never</span></td>
                        <td className='w-80'> <span className='eleHeader'>Almost</span></td>
                        <td className='w-100'> <span className='eleHeader'>Sometimes</span></td>
                        <td className='w-70'> <span className='eleHeader'>Often</span></td>
                        <td className='w-130'> <span className='eleHeader'>Almost Always</span></td>
                        <td className='w-100'> <span className='eleHeader'>Item Score</span></td>
                        </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-200'>I felt mad.</td>
                        <td className='w-70'><center><input type='radio' id='rbIFeltMad_1' name='rbIFeltMad' className='add-only' value='Never'/></center></td>
                        <td className='w-80'><center><input type='radio' id='rbIFeltMad_2' name='rbIFeltMad' className='add-only' value='Almost'/></center></td>
                        <td className='w-100'><center><input type='radio' id='rbIFeltMad_3' name='rbIFeltMad' className='add-only' value='Sometimes'/></center></td>
                        <td className='w-70'><center><input type='radio' id='rbIFeltMad_4' name='rbIFeltMad' className='add-only' value='Often'/></center></td>
                        <td className='w-130'><center><input type='radio' id='rbIFeltMad_5' name='rbIFeltMad' className='add-only' value='AlmostAlways'/></center></td>
                        <td className='w-100'><center><input type='text' id='txtIFeltMad' name='txtIFeltMad' className='add-only' /></center></td>
                        </tr>

                        <tr>
                        <td className='w-200'>I was so angry I felt like throwing something.</td>
                        <td className='w-70'><center><input type='radio' id='rbIWasSoAngryIFelt_1' name='rbIWasSoAngryIFelt' className='add-only' value='Never'/></center></td>
                        <td className='w-80'><center><input type='radio' id='rbIWasSoAngryIFelt_2' name='rbIWasSoAngryIFelt' className='add-only' value='Almost'/></center></td>
                        <td className='w-100'><center><input type='radio' id='rbIWasSoAngryIFelt_3' name='rbIWasSoAngryIFelt' className='add-only' value='Sometimes'/></center></td>
                        <td className='w-70'><center><input type='radio' id='rbIWasSoAngryIFelt_4' name='rbIWasSoAngryIFelt' className='add-only' value='Often'/></center></td>
                        <td className='w-130'><center><input type='radio' id='rbIWasSoAngryIFelt_5' name='rbIWasSoAngryIFelt' className='add-only' value='AlmostAlways'/></center></td>
                        <td className='w-100'><center><input type='text'  id='txtIWasSoAngryIFelt' name='txtIWasSoAngryIFelt' className='add-only'/></center></td>

                        </tr>

                        <tr>
                        <td className='w-200'>I Was so angry I felt like yelling at somebody.</td>
                        <td className='w-70'><center><input type='radio' id='rbIWasSoAngryIFeltLikeYelling_1' name='rbIWasSoAngryIFeltLikeYelling' className='add-only' value='Never'/></center></td>
                        <td className='w-80'><center><input type='radio' id='rbIWasSoAngryIFeltLikeYelling_2' name='rbIWasSoAngryIFeltLikeYelling' className='add-only' value='Almost'/></center></td>
                        <td className='w-100'><center><input type='radio' id='rbIWasSoAngryIFeltLikeYelling_3' name='rbIWasSoAngryIFeltLikeYelling' className='add-only' value='Sometimes'/></center></td>
                        <td className='w-70'><center><input type='radio' id='rbIWasSoAngryIFeltLikeYelling_4' name='rbIWasSoAngryIFeltLikeYelling' className='add-only' value='Often'/></center></td>
                        <td className='w-130'><center><input type='radio' id='rbIWasSoAngryIFeltLikeYelling_5' name='rbIWasSoAngryIFeltLikeYelling' className='add-only' value='AlmostAlways'/></center></td>
                        <td className='w-100'><center><input type='text'  id='txtIWasSoAngryIFeltLikeYelling' name='txtIWasSoAngryIFeltLikeYelling' className='add-only'/></center></td>
                        </tr>

                        <tr>
                        <td className='w-200'>When I Got Mad, I Stayed mad.</td>
                        <td className='w-70'><center><input type='radio' id='rbWhenIGotMadStayedMad_1' name='rbWhenIGotMadStayedMad' className='add-only' value='Never'/></center></td>
                        <td className='w-80'><center><input type='radio' id='rbWhenIGotMadStayedMad_2' name='rbWhenIGotMadStayedMad' className='add-only' value='Almost'/></center></td>
                        <td className='w-100'><center><input type='radio' id='rbWhenIGotMadStayedMad_3' name='rbWhenIGotMadStayedMad' className='add-only' value='Sometimes'/></center></td>
                        <td className='w-70'><center><input type='radio' id='rbWhenIGotMadStayedMad_4' name='rbWhenIGotMadStayedMad' className='add-only' value='Often'/></center></td>
                        <td className='w-130'><center><input type='radio' id='rbWhenIGotMadStayedMad_5' name='rbWhenIGotMadStayedMad' className='add-only' value='AlmostAlways'/></center></td>
                        <td className='w-100'><center><input type='text'  id='txtWhenIGotMadStayedMad' name='txtWhenIGotMadStayedMad' className='add-only'/></center></td>
                        </tr>

                        <tr>
                        <td className='w-200'>I felt fed up.</td>
                        <td className='w-70'><center><input type='radio' id='rbIfeltFedUp_1' name='rbIfeltFedUp' className='add-only' value='Never'/></center></td>
                        <td className='w-80'><center><input type='radio' id='rbIfeltFedUp_2' name='rbIfeltFedUp' className='add-only' value='Almost'/></center></td>
                        <td className='w-100'><center><input type='radio' id='rbIfeltFedUp_3' name='rbIfeltFedUp' className='add-only' value='Sometimes'/></center></td>
                        <td className='w-70'><center><input type='radio' id='rbIfeltFedUp_4' name='rbIfeltFedUp' className='add-only' value='Often'/></center></td>
                        <td className='w-130'><center><input type='radio' id='rbIfeltFedUp_5' name='rbIfeltFedUp' className='add-only' value='AlmostAlways'/></center></td>
                        <td className='w-100'><center><input type='text'  id='txtIfeltFedUp' name='txtIfeltFedUp' className='add-only' /></center></td>
                        </tr>

                        <tr>
                        <td className='w-200'>I felt upset.</td>
                        <td className='w-70'><center><input type='radio' id='rbIFeltUpset_1' name='rbIFeltUpset' className='add-only' value='Never'/></center></td>
                        <td className='w-80'><center><input type='radio' id='rbIFeltUpset_2' name='rbIFeltUpset' className='add-only' value='Almost'/></center></td>
                        <td className='w-100'><center><input type='radio' id='rbIFeltUpset_3' name='rbIFeltUpset' className='add-only' value='Sometimes'/></center></td>
                        <td className='w-70'><center><input type='radio' id='rbIFeltUpset_4' name='rbIFeltUpset' className='add-only' value='Often'/></center></td>
                        <td className='w-130'><center><input type='radio' id='rbIFeltUpset_5' name='rbIFeltUpset' className='add-only' value='AlmostAlways'/></center></td>
                        <td className='w-100'><center><input type='text'  id='txtIFeltUpset' name='txtIFeltUpset' className='add-only'/></center></td>
                        </tr>

                        <tr>
                            <td className='w-650'>Total/Partial Raw Score:</td>
                            <td className='w-100'><input type='text'  id='txtTotalRawScore' name='txtTotalRawScore' className='add-only'/></td>
                        </tr>

                        <tr>
                            <td className='w-650'>Prorated Total Raw Score:</td>
                            <td className='w-100'><input type='text'  id='txtProratedRawScore' name='txtProratedRawScore' className='add-only'/></td>
                        </tr>

                        <tr>
                            <td className='w-650'>T-Score:</td>
                            <td className='w-100'><input type='text'  id='txtTScore' name='txtTScore' className='add-only'/></td>
                        </tr>
                </table>

                <p className='w-750'><span className='small'>The PROMIS measure was developed for and can be used with children ages 8-17.<br />
                <sup>1</sup>{`This measure was not tested in the DSM-5 Field Trials.`}<br />
                &#169; 2008-2012 PROMIS Health Organization (PHO) and PROMIS Cooperative Group.<br />
                The material can be reproduced without permission by clinicians for use with their patients.<br />
                Any other use, including electronic use, requires written permission of the PHO.</span></p>




 


            </div>
        </form>

    )
}  
